/**
 * Collection of legal agreements and terms used across the application
 */

export const ARTIST_AGREEMENT = `Artist Agreement

1. Parties
This agreement ("Agreement") is between Kuluko Oy, doing business as GetMoreTats ("GetMoreTats" or "the Platform") and the undersigned tattoo artist ("Artist").

2. Term & Termination
Either party may end this Agreement at any time by written notice (such as email or Instagram message). Upon termination of this Agreement, the Artist's profile, portfolio, and related content will be removed from the Platform's website and app.

3. Artist Warranties
The Artist confirms that all tattoo work follows applicable health, safety, and licensing laws, and that any reference art used does not infringe third-party rights.

4. Independent Contractor
The Artist is an independent contractor; nothing here creates employment, partnership, or agency.

5. Severability & Entire Agreement
If any clause is unenforceable, the rest remains in effect. This Agreement is the entire understanding between the parties and overrides prior discussions. Changes require written notice and acceptance by both parties (email counts).`

/**
 * Key points summary of the artist agreement for UI display
 */


export const ARTIST_AGREEMENT_KEY_POINTS = [
  { title: 'Termination', description: 'Either party can end the agreement with written notice; profile is removed on termination' },
  { title: 'Warranties', description: 'Follow health, safety, and licensing laws; do not infringe third-party rights' },
  { title: 'Independent Contractor', description: 'You remain self-employed' },
  { title: 'Entire Agreement', description: 'Changes require written notice and acceptance by both parties' }
]
